import { APIKit } from 'config/axios/index';
import { AppConstants, ServerConstants, ServiceConstants } from '../constants';
import store from 'config/redux/index';
import { end, start } from 'config/redux/slice';
import { ServiceModel } from 'models';
import { handleErrorWithTokenRenewal } from './common';
import { CreditResponse, ICreditRequestUpdate, LoginResponse, RequestVerifyForm } from 'types';
import { AppUtils, StorageUtils } from 'utils';

const {
  STORAGE_ACCESS_TOKEN,
  STORAGE_VALID_TO,
} = AppConstants;

const {
  API_V1_WEB_CREDIT,
} = ServerConstants;

const {
  REQUEST_CREDIT_OPTIONS_ID,
  REQUEST_CREDIT_UNREQUESTED_ID,
  REQUEST_CREDIT_REQUEST_ID,
  REQUEST_CREDIT_CREATE_ID,
  REQUEST_CREDIT_MULTIPLE_UPDATE_ID,
  REQUEST_CREDIT_SUBMIT_ID,
  REQUEST_CREDIT_ATTACHMENTS_ID,
  REQUEST_CREDIT_ATTACHMENTS_UPLOAD_ID,
  REQUEST_CREDIT_VERIFY_ID,
} = ServiceConstants

export async function creditOptions() {
  const requestId = REQUEST_CREDIT_OPTIONS_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_WEB_CREDIT}/options`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, creditOptions, [], requestId);
  }
}

export async function getUnrequested() {
  const requestId = REQUEST_CREDIT_UNREQUESTED_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_WEB_CREDIT}/unrequested`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, getUnrequested, [], requestId);
  }
}

export async function getRequest(cid: string) {
  const requestId = REQUEST_CREDIT_REQUEST_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_WEB_CREDIT}/${cid}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, getRequest, [cid], requestId);
  }
}

export async function createRequest(data: CreditResponse) {
  const requestId = REQUEST_CREDIT_CREATE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(API_V1_WEB_CREDIT, { ...data, source: 'WEB' });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, createRequest, [data], requestId);
  }
}

export async function updateRequestMultiple(cid: string, data: ICreditRequestUpdate[]) {
  const requestId = REQUEST_CREDIT_MULTIPLE_UPDATE_ID;
  try {
    store.dispatch(start(requestId));
    data.forEach(el => {
      let val = data[el.name as any];
        if (val) {
          data[el.name as any] = AppUtils.convertToAppropriateValue(el.value);
        }
    });
    const response = await APIKit.patch(`${API_V1_WEB_CREDIT}/${cid}`, data);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, updateRequestMultiple, [cid, data], requestId);
  }
}

export async function submitRequest(cid: string) {
  const requestId = REQUEST_CREDIT_SUBMIT_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_WEB_CREDIT}/${cid}/request`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, submitRequest, [cid], requestId);
  }
}

export async function getAttachments(cid: string) {
  const requestId = REQUEST_CREDIT_ATTACHMENTS_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_WEB_CREDIT}/${cid}/attachments`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, getAttachments, [cid], requestId);
  }
}

export async function uploadAttachments(cid: string, files: any) {
  const requestId = REQUEST_CREDIT_ATTACHMENTS_UPLOAD_ID;
  try {
    store.dispatch(start(requestId));
    const formData = new FormData();
    files.forEach((file: any) => {
      formData.append('files', file);
    });
    const response = await APIKit.post(`${API_V1_WEB_CREDIT}/${cid}/attachments`, formData, {
      headers: {
        ...APIKit.defaults.headers['common'],
        'Accept-Language': APIKit.defaults.headers['Accept-Language'],
        'Content-Type': 'multipart/form-data'
      }
    });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, uploadAttachments, [cid, files], requestId);
  }
}

export async function verify(data: RequestVerifyForm) {
  const requestId = REQUEST_CREDIT_VERIFY_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_WEB_CREDIT}/verify`, { ...data });
    const loginData: LoginResponse = response.data;
    StorageUtils.setObject(STORAGE_ACCESS_TOKEN, loginData.accessToken);
    StorageUtils.setObject(STORAGE_VALID_TO, loginData.validTo);
    store.dispatch(end(new ServiceModel(requestId)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, verify, [data], requestId);
  }
}